var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9056 17.7158L17.5126 15.8658C16.6533 15.3972 15.5663 15.6361 14.9864 16.4214L13.6208 18.2707C12.168 17.4523 10.6048 15.9907 9.33586 14.5116C8.05656 13.0198 7.04516 11.8236 6.46205 9.9038L8.7218 8.57861C9.57115 8.08075 9.90768 7.04145 9.50412 6.16352L7.91344 2.70296C7.53193 1.87347 6.50503 1.54969 5.68975 1.99858C4.06026 2.89582 1.68359 4.48341 1.35543 6.25257C0.951531 10.5841 2.2982 14.8012 5.14962 18.1252C7.99867 21.4497 12.0064 23.4749 16.4426 23.8404C18.3714 23.8875 20.3356 21.5282 21.4415 19.9306C21.9625 19.1781 21.712 18.1556 20.9056 17.7158Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bccc5f28ad198af5332e368f2c88f208.svg";
export { ForwardRef as ReactComponent };